/// <reference path="../node_modules/@types/jquery/JQuery.d.ts" />
import Alpine from 'alpinejs';
import { globalScripts } from "./global-scripts";
import { heroWidgetScripts } from "../widgets/hero/hero-widget";
import { imageLinkBlocksWidgetScripts } from "../widgets/image-link-blocks/image-link-blocks-widget";
import { statementCalloutWidgetScripts } from "../widgets/statement-callout/statement-callout-widget";
import { horizontalStatsWidgetScripts } from "../widgets/horizontal-stats/horizontal-stats-widget";
import { storiesWidgetScripts } from "../widgets/stories/stories-widget";
import { tabsWidgetScripts } from "../widgets/tabs/tabs-widget";
import { verticalStatsWidgetScripts } from "../widgets/vertical-stats/vertical-stats-widget";
import { promoWidgetScripts } from "../widgets/promo/promo-widget";
import { initSplitPromo } from "../widgets/split-promo/split-promo-widget";
import { initTextLinkBlocks } from "../widgets/text-link-blocks/text-link-blocks-widget";
import { initQuoteWidget } from "../widgets/quote/quote-widget";
import { initExpandableContainers } from "../widgets/expandable-containers/expandable-containers-widget";
import { initExpandableBios } from "../widgets/expandable-bios/expandable-bios-widget";
import { initCommunityDataSnapshot } from "../widgets/community-data-snapshot/community-data-snapshot-widget";
import { initReportsFiltersWidgets } from "../widgets/reports-filters/reports-filters-widget";
import { initReportsListingWidgets } from "../widgets/reports-listing/reports-listing-widget";
import { initReportHeaderWidgets } from "../widgets/report-header/report-header-widget";
import { initVideoWidgets } from "../widgets/video/video-widget";
import { initCrossPromotionWidgets } from "../widgets/cross-promotion/cross-promotion-widget";
import { initDocumentDownloadWidgets } from "../widgets/document-download/document-download-widget";
import { initNumberedListWidgets } from "../widgets/numbered-list/numbered-list-widget";
import { initNewsWidget } from "../widgets/news/news-widget";
import { initGrantsWidget } from "../widgets/grants-widget/grants-widget";
globalScripts();
heroWidgetScripts();
imageLinkBlocksWidgetScripts();
statementCalloutWidgetScripts();
horizontalStatsWidgetScripts();
storiesWidgetScripts();
tabsWidgetScripts();
verticalStatsWidgetScripts();
promoWidgetScripts();
initSplitPromo();
initTextLinkBlocks();
initQuoteWidget();
initExpandableContainers();
initExpandableBios();
initCommunityDataSnapshot();
initReportsFiltersWidgets();
initReportsListingWidgets();
initReportHeaderWidgets();
initVideoWidgets();
initCrossPromotionWidgets();
initDocumentDownloadWidgets();
initNumberedListWidgets();
initNewsWidget();
initGrantsWidget();
Alpine.start();
